import createIcon from '../../createIcon';

/**
 * @component @name PermScanWifi
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMi41QzYuOTUgMi41IDMuMTUgNC4zNSAwIDYuNzNMMTIgMjEuNUwyNCA2Ljc1QzIwLjg1IDQuMzcgMTcuMDUgMi41IDEyIDIuNVpNMTMgMTUuNUgxMVY5LjVIMTNWMTUuNVpNMTEgNy41VjUuNUgxM1Y3LjVIMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PermScanWifi = createIcon('PermScanWifi', [
  [
    'path',
    {
      d: 'M12 2.5C6.95 2.5 3.15 4.35 0 6.73L12 21.5L24 6.75C20.85 4.37 17.05 2.5 12 2.5ZM13 15.5H11V9.5H13V15.5ZM11 7.5V5.5H13V7.5H11Z',
      key: '177fqn',
    },
  ],
]);

export default PermScanWifi;
